interface MatchCriteria {
  [key: string]: string[];
}

export interface CriteriaConfig {
  criteria: MatchCriteria;
  customMainText?: string;
  customTitle?: string;
  customButton?: {
    label: string;
    url: string;
  };
  customProductType?: string;
  displayText: string;
  displayImageFileName?: string;
  displayTextInfoOptions?: {
    pattern: string;
    label: string;
    url: string;
  }[];
}

const getMatchingThankYouPageInfo = (
  mainCriteria: CriteriaConfig[],
  salesOrderData: any
): CriteriaConfig | null => {
  if (!mainCriteria || !salesOrderData || Object.keys(salesOrderData).length === 0) {
    return null;
  }

  const matchedElement =
    mainCriteria.find((criteriaElement) => {
      if (!criteriaElement.criteria) {
        return false;
      }

      return Object.entries(criteriaElement.criteria).every(([fieldName, requiredValueList]) => {
        const userValue = salesOrderData[fieldName] || [];
        const isIncluded = requiredValueList.some((requiredValue) =>
          userValue.includes(requiredValue)
        );

        return isIncluded;
      });
    }) || null;

  return matchedElement;
};

export default getMatchingThankYouPageInfo;
